import React from 'react';
import { Box, GlobalStyles, Stack, Typography } from '@mui/material';
import { useTranslation } from '../../context/Internationalization';
import { colors } from '../../theme/colors';
import { playFontFaces } from '../../theme/fonts';
import { managerLogo as logo } from '../../assets/managerBranding';
import stadium from '../../assets/images/registration/stadium-seats.jpg';

export default function AuthLayout({ children, clubLogo }) {
  const { t, lang, switchLanguage } = useTranslation();
  return (
    <Box component="main" sx={{ minHeight: '100vh', bgcolor: 'white', boxSizing: 'border-box',
      '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
      // Auth pages do not mount the signed-in AppShell's CssBaseline.
      '& *, & *::before, & *::after': { boxSizing: 'inherit' },
      display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) minmax(0, 1fr)' },
      gap: { xs: 0, md: 3 }, p: { xs: 2, md: 3 }, color: colors.Grey[900] }}>
      <GlobalStyles styles={playFontFaces} />
      <Box component="aside" sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'column',
        justifyContent: 'flex-end', p: 6, borderRadius: '14px', minHeight: 0,
        color: 'white', backgroundImage: `linear-gradient(rgba(0,0,0,.6), rgba(0,0,0,.6)), url(${stadium})`,
        backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <Stack spacing={2} sx={{ maxWidth: 430 }}>
          <Box component="img" src={clubLogo || logo} alt={clubLogo ? t('registration_logo_preview') : 'PlayerDex'}
            sx={{ width: 40, height: 40, borderRadius: '8px', objectFit: 'contain' }} />
          <Typography variant="h4" component="h2" sx={{ fontSize: 32, fontWeight: 700, textWrap: 'balance' }}>{t('registration_brand_title')}</Typography>
          <Typography sx={{ fontSize: 18, lineHeight: 1.65 }}>{t('registration_brand_description')}</Typography>
          <Typography sx={{ color: colors.Grey[200] }}>{t('registration_brand_details')}</Typography>
        </Stack>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center',
        alignItems: 'center', minWidth: 0, px: { xs: 0, lg: 3 } }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between"
          sx={{ width: '100%', maxWidth: 384, mb: 3 }}>
          <Box component="img" src={logo} alt="PlayerDex Manager" sx={{ width: 36, height: 36 }} />
          <Box component="select" aria-label={t('registration_language')} value={lang}
            onChange={(event) => switchLanguage(event.target.value)}
            sx={{ fontFamily: 'inherit', fontSize: 14, border: `1px solid ${colors.Grey[300]}`,
              p: 1, borderRadius: '8px', bgcolor: 'white', color: colors.Grey[700] }}>
            <option value="gr">Ελληνικά</option><option value="en">English</option>
          </Box>
        </Stack>
        <Box sx={{ width: '100%', maxWidth: 384,
          '& h1': { fontSize: 30, fontWeight: 700, lineHeight: 1.3, textWrap: 'balance' },
          '& .MuiButton-contained': { color: colors.Grey[900] },
          '& .MuiButton-text': { bgcolor: 'transparent', borderColor: 'transparent', color: colors.Grey[700],
            '&:hover, &:focus': { bgcolor: colors.Grey[50] } },
          '& .MuiButton-outlined': { bgcolor: 'white', borderColor: colors.Grey[300], color: colors.Grey[900],
            '&:hover, &:focus': { bgcolor: colors.Grey[50] } },
          '& a, & .MuiInputLabel-root.Mui-focused, & .MuiCheckbox-root.Mui-checked': { color: colors.Primary[800] },
          '& .MuiButton-root:focus-visible, & .Mui-focusVisible, & a:focus-visible': {
            outline: `3px solid ${colors.Primary[800]}`, outlineOffset: 3,
          } }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
